<template>
	<div class="category-animation-6-bg abs">
		<!--<transition name="fade-long">
			<div v-if="withFade" class="category-animation-5-bg__fade"></div>
		</transition>-->
		<video autoplay
			   muted
			   loop
			   playsinline
			   class="anim-fade-in"
			   @loadeddata="withFade=false">
			<source src="@/assets/animations/6/bg.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: "category-animation-6-bg",
		components: {},
		data: () => {
			return {
				withFade: false,
			}
		},
	}
</script>

<style lang="scss">
	.category-animation-6-bg {
		top: 46%;
		width: 60vw;
		height: 280px;

		/*@include up($md) {
			height: 280px;
		}

		@include up($lg) {
			height: 320px;
		}*/

		video {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

</style>